module.exports = __webpack_public_path__ + "img/064fda6.png";